<a [routerLink]="impacterId">
  <div class="document-card" [ngClass]="{ 'suggestion-card': !byFilter }">
    <div class="col-3 impacter-name" [innerHTML]="name"></div>
    <div class="col-9 impacter-positions">
      @for (position of shownPositions | slice: 0 : 2; track position) {
        <div class="row position-item">
          <div class="col-6 impacter-role">
            @if (position.isOld) {
              <span class="old-role">{{ 'content.old' | translate }} </span>
            }
            <span>{{ position['role'] }}</span>
            <span class="dot"></span>
          </div>
          <div class="col-6 align-self-end">
            <span>{{ position['territory']['name'] }}</span>
          </div>
        </div>
      }
    </div>
  </div>
</a>
